//import components
import './Admindashboard.css';
import React, { useMemo,useEffect,useState } from "react";
import Breadcrumbs from '../../../Components/Common/Breadcrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import { APIClient } from "../../../helpers/api_helper";
import { subscribeToTokenRefresh } from "../../../helpers/Refreshfile";
import { Modal, ModalHeader, Badge,  Card, CardBody, Row, Col, UncontrolledTooltip,Alert, DropdownToggle,UncontrolledDropdown ,DropdownMenu, Input, Label, Button } from 'reactstrap';
import defaultUserImg from "../../../assets/images/defaultuserimgdark.png"
import axios from 'axios';
import { sendNotification } from '../../../helpers/common_api_calls';
import CustomerDetailModal from '../../../Components/custom/CustomerDetailModal';
const api = new APIClient();
const baseUrl = process.env.REACT_APP_BASE_URL;


// interface column {
//     header: string,
//     accessorKey: string,
//     enableColumnFilter: boolean,
//     enableSorting: boolean,
// }

interface column {
    header: string;
    accessorKey?: string;
    accessorFn?: (row: any) => string;
    enableColumnFilter: boolean;
    enableSorting: boolean;
    cell?: (info: any) => React.ReactNode;
}




const AdminCustomerApprovals = () => {


    const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
    const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
        if (reason === "clickaway") { return; }
        setAlertMsgg({ ...alertMsgg, open: false })
    };
    const [showloader, setshowloader] = useState(true);


    const [cancelUserId, setCancelUserId] = useState<string | null>(null);
    const [get_cancel_subs, set_cancel_subs] = useState(false);
    const [alert, setAlert] = useState<{ message: string; type: 'success' | 'danger'; show: boolean }>({ message:'', type: 'success', show: false });
    const [cancel_sup_popup, set_cancel_cub_popup] = useState(false);

    const closeCancelModal = () => {
        set_cancel_cub_popup(false); // close the modal
        setCancelUserId(null);    // optional: reset the ID
    };
    console.log('get_cancel_subs',get_cancel_subs)
    const showAlert = (message: string, type: 'success' | 'danger') => {
        setAlert({ message, type, show: true });
        setTimeout(() => setAlert({ message: '', type: 'success', show: false }), 5000);
    };

    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }
    function cancelSubs(id: string) {
        setCancelUserId(id)
        set_cancel_cub_popup(!cancel_sup_popup);
        removeBodyCss();
    } 

    const subscriptioncancle = async (cst_Id: string | null) => {
        if (!cst_Id) {
            setAlertMsgg({...alertMsgg,open: true,content: "No user ID to cancel subscription",type: "error",});
            setTimeout(() => {
                setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
            }, 2000);
            return;}
        console.log('userId______________',localStorage.getItem('authUser'))
        console.log('cst_id______________',cst_Id)

        try {
            setshowloader(true)
            const res = await axios.post("/accounts/subscription_cancle", {
                user_id: localStorage.getItem('authUser'),
                cst_id:cst_Id,
            });
            if (res.status === 'cancelled'){
                
                set_cancel_cub_popup(!cancel_sup_popup);
                fetch_customerlisting()
                setAlertMsgg({...alertMsgg,open: true,content: "Subscription has been canceled successfully",type: "success",});
                setTimeout(() => {
                    setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
                }, 4000);
            }
            setshowloader(false);
        } catch (error:any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                    console.log('Error in stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: error.response.error, type: "error" });
                }
                else if (error.response.status === 403) {
                    console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                    console.log('An error occurred')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false)
        }
    };
    
    // Stripe mode check state - MUST be declared before columns useMemo
    const [checkingStripe, setCheckingStripe] = useState<Record<string, boolean>>({});
    const [stripeCheckResults, setStripeCheckResults] = useState<Record<string, any>>({});
    
    const columns: column[] = useMemo(
        () => [
            {
                header: 'S.No',
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row, table }) => {
                    return row.index + 1;
                },
            },
            {
                header: 'ID',
                accessorKey: 'id',
                enableColumnFilter: false,
                enableSorting: false,
                cell: (({row}:any) => {
                    return row?.original?.user?.id
                })
            },
            {
            header: 'Customer Info',
            accessorFn: (row: any) => {
                console.log('check yaha ka rok',row)
                const first_name = row?.user?.first_name || '';
                const email = row?.user?.email || '';
                const time  =  row?.original?.cstpack?.created_at;
                return `${first_name} ${email} ${time}`;
            },
            enableColumnFilter: false,
            enableSorting: true,
            cell: (info: any) => {
                const row = info.row.original;
                const first_name = row?.user?.first_name;
                const email = row?.user?.email;
                const time = row?.cstpack?.created_at;
                const attachment = row?.user?.profile_pic;
            
                return (
                    <div className="d-flex align-items-center">
                        <img
                            src={attachment ? `${baseUrl}${attachment}` : defaultUserImg}
                            alt="User"
                            width="50"
                            height="50"
                            className="rounded-circle object-fit-cover"
                            style={{ marginRight: '10px' }}
                            onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = defaultUserImg;
                            }}
                        />
                        <div>
                            <div className="fw-medium">{first_name || "No first name"}</div>
                            <div className="font-size-12">{email || "No email"}</div>
                            <div className="font-size-12"><i className="bx bx-calendar-event font-size-14"></i>{time ? new Date(time).toLocaleString('en-GB', {day: '2-digit',
                                    month: 'short',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',}): ""}
                            </div>

                        </div>
                    </div>
                );
            }
            }, 
            {
                header: 'Phone',
                accessorKey: 'user.phone',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Address',
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }: any) => {
                    const r = row.original || {};
                    const parts: string[] = [];
                    if (r.address_line1) parts.push(r.address_line1);
                    if (r.address_line2) parts.push(r.address_line2);
                    const cityStateZip = [r.city, r.state, r.zipcode].filter(Boolean).join(' ');
                    if (cityStateZip) parts.push(cityStateZip);
                    if (r.country) parts.push(r.country);
                    const full = parts.join(', ');
                    return full ? (
                        <div className="font-size-12 text-wrap" style={{maxWidth: 260}}>{full}</div>
                    ) : (
                        <span className="text-muted">--</span>
                    );
                }
            },
            {
                header: 'Package Details',
                accessorKey: 'cstpack.plat_pack', 
                enableColumnFilter: false,
                enableSorting: false, 
                cell: ({ row }) => {
                    const pack = row.original.cstpack?.plat_pack;
                    return (  (row.original.cstpack) ? (
                        <div className="">
                            <p className="mb-0"><span className="fw-medium">{pack?.name}</span> - ${pack?.price} </p>
                            <p className="font-size-12"><i className="bx bx-calendar-event font-size-14"></i> {row?.original?.cstpack?.created_at ? new Date(row?.original?.cstpack?.created_at).toLocaleString('en-GB', {day: '2-digit',
                                    month: 'short',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',}): ""}</p>
                            
                        </div> ): ( <div className="text-center"> " -- " </div> )
                    );
                },
            },
            {
                header: 'Package Status',
                accessorKey: 'cstpack.payment_status',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps: any) => {
                    const rawStatus = cellProps.row.original.cstpack?.payment_status;
                    const status = rawStatus ? rawStatus.toLowerCase() : 'pending';
                    const subscrip_status = cellProps.row.original.cstpack?.subscrip_cancelled
                    const finalStatus = subscrip_status === true ? 'expired' : status;
                    const statusClassMap: Record<string, string> = {
                        paid: 'success',
                        pending: 'warning',
                        failed: 'danger',
                        expired: 'dark',
                    };
            
                    const badgeClass = statusClassMap[finalStatus] || 'secondary';
            
                    return (
                        <Badge className={`font-size-11 badge-soft-${badgeClass}`}>
                            {finalStatus ? finalStatus.charAt(0).toUpperCase() + finalStatus.slice(1) : 'N/A'}
                        </Badge>
                    );
                },
            },
            {
                header: 'Companies',
                accessorKey: 'company_count',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }: any) => {
                    const count = row.original.company_count || 0;
                    return (
                        <div className="text-center">
                            <button
                                className="btn btn-sm btn-soft-primary"
                                onClick={() => openCustomerDetail(row.original)}
                                disabled={count === 0}
                                id={`companies-${row.original.id}`}
                            >
                                <i className="bx bx-buildings me-1"></i>
                                {count}
                            </button>
                            {count > 0 && (
                                <UncontrolledTooltip placement="top" target={`companies-${row.original.id}`}>
                                    View Companies
                                </UncontrolledTooltip>
                            )}
                        </div>
                    );
                }
            },
            {
                header: 'Action',
                accessorKey: 'admin_verified',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }: any) => {
                    const isVerified = row.original.admin_verified;  
                    const isActive = row.original.user.is_active;
                    const pack_active = row.original.cstpack?.pack_active;
                    const sub_cancel = row.original.cstpack?.subs_cancel;
                    
                    return (
                        <div style={{ textAlign: 'start' }}>
                            {(isVerified === 'verified') || (isVerified === 'paid') ? (
                                // Show only the "Unverify" button (green check) if verified
                                <div className="d-flex justify-content-start gap-2 align-items-start">
                                    <label className="switch">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="customSwitchsizesm"
                                            checked={isActive}
                                            onChange={async (e) => {
                                                const newVerifiedStatus = e.target.checked;
                                                console.log('newVerifiedStatus',newVerifiedStatus)
                                                setshowloader(true);
                                                try {
                                                    await api.create('/accounts/user_active_change', {
                                                        admin_verified: newVerifiedStatus,
                                                        eid: row.original.id,
                                                    });
                                                     setAlertMsgg({
                                                            ...alertMsgg,
                                                            open: true,
                                                            content: `User ${newVerifiedStatus ? 'activated' : 'deactivated'} successfully`,
                                                            type: 'success'
                                                        });

                                                        setTimeout(() => {
                                                            setAlertMsgg({ ...alertMsgg, open: false, content: '', type: '' });
                                                        }, 2000);
                                                    setshowloader(false);

                                                    fetch_customerlisting();
                                                    // showAlert(`User ${newVerifiedStatus ? 'activated' : 'deactivated'} successfully`,'success');
                                                } catch (error:any) {
                                                        if (error.response) {
                                                            if ([401, 422].includes(error.response.status)) {
                                                            console.log('Error in stripe payment')
                                                            setAlertMsgg({ ...alertMsgg, open: true, content: error.response.error, type: "error" });
                                                            }
                                                            else if (error.response.status === 403) {
                                                            console.log('Error stripe payment')
                                                                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                                                                setTimeout(()=>{window.location.href="/logout"}, 2000)
                                                            } else {
                                                            console.log('An error occurred')
                                                            setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                                                            }
                                                        } else {
                                                        console.log('An error occurred')
                                                        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
                                                        }
                                                        setshowloader(false); 
                                                    }
                                            }}
                                        />
                                        <span className="slider round"></span>
                                    </label>
                                    {((pack_active === true) || (sub_cancel === false)) && (
                                        <>
                                            <UncontrolledTooltip placement="top" target="Emojitooltip">
                                                Cancel Subscription
                                            </UncontrolledTooltip>
                                            <button
                                                className="btn btn-dark ms-1 btn-sm"
                                                id="Emojitooltip"
                                                onClick={() => cancelSubs(row.original?.id)}
                                            >
                                                <i className="bx bx-x"></i> Cancel
                                            </button>
                                        </>
                                    )}
                                    {(row.original.can_delete) ? (
                                
                                        <button className="btn btn-danger btn-sm" id="deletecstomer" onClick={()=>{deletecustomer(row.original.id);}}>
                                            <UncontrolledTooltip placement="top" target="deletecstomer">
                                                Delete Customer
                                            </UncontrolledTooltip>
                                            <i className="bx bxs-trash-alt me-1" ></i>Delete
                                        </button>
                                    ) : null}
                                    
                                    {/* Stripe Mode Check Button */}
                                    {row.original.stripe_acc && (
                                        <div className="mt-2">
                                            <button
                                                className="btn btn-sm btn-outline-primary"
                                                onClick={() => checkStripeMode(row.original.id, row.original.stripe_acc)}
                                                disabled={checkingStripe[`customer_${row.original.id}`]}
                                                style={{fontSize: 11, padding: '4px 12px'}}
                                            >
                                                <i className="bx bx-search" style={{marginRight: 4}}></i>
                                                {checkingStripe[`customer_${row.original.id}`] ? 'Checking...' : 'Check Stripe'}
                                            </button>
                                            {renderStripeCheckResult(row.original.id)}
                                        </div>
                                    )}
                                    
                                </div>
                                
                                
                            ) : ( (isVerified === 'unverified') ?
                                (<>
                                    <div className="d-flex gap-2">
                                        <button className="btn btn-success btn-sm"
                                            onClick={async () => {
                                                console.log('Approving user:', row.original);
                                                setshowloader(true);
                                                try {
                                                    const res = await api.create('/accounts/admin_verified_customer', {
                                                        admin_verified: true,
                                                        cust_id: row.original.id,
                                                        decision:'accept'
                                                    });
                                                    if (res.status === 'CUSTOMER_VERIFIED') {
                                                        // showAlert('Customer approved successfully','success');
                                                        setAlertMsgg({ ...alertMsgg, open: true, content:"Customer approved successfully", type:"success" })
                                                        setTimeout(() => {
                                                            setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
                                                        }, 2000);
                                                        setshowloader(false);
                                                        fetch_customerlisting();
                                                    } else {
                                                        showAlert('Approval failed','danger');
                                                        fetch_customerlisting();
                                                    }
                                                } catch (error:any) {
                                                    if (error.response) {
                                                        if ([401, 422].includes(error.response.status)) {
                                                        console.log('Error in stripe payment')
                                                        setAlertMsgg({ ...alertMsgg, open: true, content: error.response.error, type: "error" });
                                                        }
                                                        else if (error.response.status === 403) {
                                                        console.log('Error stripe payment')
                                                            setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                                                            setTimeout(()=>{window.location.href="/logout"}, 2000)
                                                        } else {
                                                        console.log('An error occurred')
                                                        setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                                                        }
                                                    } else {
                                                    console.log('An error occurred')
                                                    setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
                                                    }
                                                    setshowloader(false)
                                                }
                                            }}
                                            title="Click to Approve"
                                        >
                                            <i className="bx bx-check"></i>
                                            Accept
                                            
                                        </button>
                                
                                        <button
                                            className="btn btn-danger btn-sm"
                                            onClick={async () => {
                                                console.log('Rejecting user:', row.original);
                                                setshowloader(true);
                                                try {
                                                    const res = await api.create('/accounts/admin_verified_customer', {
                                                        admin_verified: false,
                                                        cust_id: row.original.id,
                                                        decision:'reject',
                                                    });
                                                    if (res.status === 'CUSTOMER_VERIFIED') {
                                                        fetch_customerlisting();
                                                        // showAlert('Customer rejected successfully','success');
                                                        setAlertMsgg({ ...alertMsgg, open: true, content:"Customer rejected successfully", type:"success" })
                                                        setTimeout(() => {
                                                            setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
                                                        }, 2000);
                                                         setshowloader(false);
                                                    } else {
                                                        fetch_customerlisting();
                                                        showAlert('Approval failed','danger');
                                                    }
                                                } catch (error:any) {
                                                    if (error.response) {
                                                        if ([401, 422].includes(error.response.status)) {
                                                        console.log('Error in stripe payment')
                                                        setAlertMsgg({ ...alertMsgg, open: true, content: error.response.error, type: "error" });
                                                        }
                                                        else if (error.response.status === 403) {
                                                        console.log('Error stripe payment')
                                                            setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                                                            setTimeout(()=>{window.location.href="/logout"}, 2000)
                                                        } else {
                                                        console.log('An error occurred')
                                                        setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                                                        }
                                                    } else {
                                                    console.log('An error occurred')
                                                    setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
                                                    }
                                                    setshowloader(false)
                                                }
                                            }}
                                            title="Click to Reject"
                                        >
                                            <i className="bx bx-x"></i>
                                            Reject
                                        </button>
                                    </div>
                                </>) : (<Badge className="font-size-11 badge-soft-danger">Rejected </Badge> )
                            )}
                            
                        </div>
                    );
                }
            }
        ],
        [stripeCheckResults, checkingStripe, alertMsgg]
    );



    const [deleteId, setDeleteId] = useState<string | null>(null);
    const [modal_center_delete, set_delete_delete] = useState(false);
    const [customerDetailModal, setCustomerDetailModal] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState<{ id: string; name: string; email: string } | null>(null);
    
    function deletecustomer(id?: string) {
        if (id !== undefined) {   setDeleteId(id);   }
        set_delete_delete(!modal_center_delete);
        removeBodyCss();
    }

    const openCustomerDetail = (customer: any) => {
        setSelectedCustomer({
            id: customer.id,
            name: `${customer.user.first_name || ''} ${customer.user.last_name || ''}`.trim() || customer.user.email,
            email: customer.user.email
        });
        setCustomerDetailModal(true);
    };
    const handleConfirmDelete = async() => {
        if (deleteId !== null) {
            try{   
                setshowloader(true)      
                const response = await axios.post(`/accounts/delete_customer`, {'eid':deleteId}, { withCredentials: true ,headers: { 'Content-Type': 'application/json', },});
                if (response?.status === "DONE"){
                    setAlertMsgg({ ...alertMsgg, open: true, content:"Customer deleted successfuly!", type:"success" })
                    setTimeout(() => {
                    setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
                }, 4000);
                    fetch_customerlisting()
                    setshowloader(false);
                }
                else {
                    setAlertMsgg({ ...alertMsgg, open: true, content: response?.error || "Unable to delete customer.", type:"error" })
                    setshowloader(false);
                }
            } catch (error:any) {
                if (error.response) {
                    if ([401, 422].includes(error.response.status)) {
                        setAlertMsgg({ ...alertMsgg, open: true, content: error.response.error || "Request failed", type: "error" });
                    }
                    else if (error.response.status === 403) {
                        console.log('Error stripe payment')
                        setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                        setTimeout(()=>{window.location.href="/logout"}, 2000)
                    } else {
                        console.log('An error occurred')
                        setAlertMsgg({ ...alertMsgg, open: true, content: error.response.error || "An error occurred", type: "error" });
                    }
                } else {
                    console.log('An error occurred')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
                }
                setshowloader(false)
            }
        }
        set_delete_delete(false);
        setDeleteId(null);
    };

    const [bookings, setBookings] = useState<any[]>([]);
    // Filters
    const [paymentStatuses, setPaymentStatuses] = useState<string[]>(['']);
    const [selectedPackage, setSelectedPackage] = useState<string>('');
    const [dateFrom, setDateFrom] = useState<string>('');
    const [dateTo, setDateTo] = useState<string>('');
    const [activeOnly, setActiveOnly] = useState<string>(''); // '', 'active', 'inactive'
    const [hasActivePack, setHasActivePack] = useState<string>(''); // '', 'true', 'false'
    const [subsCancelled, setSubsCancelled] = useState<string>(''); // '', 'true', 'false'
    const [canDeleteOnly, setCanDeleteOnly] = useState<boolean>(false);
    const [filtersExpanded, setFiltersExpanded] = useState<boolean>(false);
    
    const checkStripeMode = async (customerId: string, stripeAcc: string | null) => {
        if (!stripeAcc) {
            setAlertMsgg({ ...alertMsgg, open: true, content: "Customer has no Stripe account ID", type: "error" });
            return;
        }
        
        const key = `customer_${customerId}`;
        setCheckingStripe(prev => ({ ...prev, [key]: true }));
        
        try {
            const response = await axios.post(
                "/payments/stripe_mode_check/",
                {
                    stripe_id: stripeAcc,
                    object_type: 'customer'
                },
                { withCredentials: true }
            );
            
            console.log('Full response:', response);
            
            if (response && response.status === "CHECKED") {
                console.log('Stripe check result:', response.results);
                console.log('Setting result with key:', key);
                setStripeCheckResults(prev => {
                    const updated = { 
                        ...prev, 
                        [key]: response.results 
                    };
                    console.log('Updated stripeCheckResults:', updated);
                    return updated;
                });
            } else {
                console.log('Unexpected response:', response);
                setAlertMsgg({ ...alertMsgg, open: true, content: `Unexpected response: ${JSON.stringify(response)}`, type: "error" });
            }
        } catch (error: any) {
            console.error('Error in checkStripeMode:', error);
            if (error.response) {
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data?.error || "Error checking Stripe mode", type: "error" });
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
        } finally {
            setCheckingStripe(prev => ({ ...prev, [key]: false }));
        }
    };
    
    const moveCustomerToLive = async (customerId: string) => {
        try {
            setshowloader(true);
            const response = await axios.post(
                "/payments/move_customer_to_live/",
                {
                    customer_id: customerId
                },
                { withCredentials: true }
            );
            
            if (response) {
                if (response.status === "MOVED_TO_LIVE") {
                    let message = response.message;
                    if (response.results && response.results.customer) {
                        message += `\nCustomer: ${response.results.customer.old_id} → ${response.results.customer.new_id}`;
                    }
                    
                    setAlertMsgg({ 
                        ...alertMsgg, 
                        open: true, 
                        content: message, 
                        type: "success" 
                    });
                    fetch_customerlisting();
                    // Clear the check results for this customer
                    const key = `customer_${customerId}`;
                    const updatedResults = { ...stripeCheckResults };
                    delete updatedResults[key];
                    setStripeCheckResults(updatedResults);
                } else if (response.error) {
                    setAlertMsgg({ 
                        ...alertMsgg, 
                        open: true, 
                        content: response.error, 
                        type: "error" 
                    });
                }
            }
            setshowloader(false);
        } catch (error: any) {
            console.error(error);
            if (error.response) {
                setAlertMsgg({ 
                    ...alertMsgg, 
                    open: true, 
                    content: error.response.data?.error || "Error moving customer to Live mode", 
                    type: "error" 
                });
            } else {
                setAlertMsgg({ 
                    ...alertMsgg, 
                    open: true, 
                    content: "Network error", 
                    type: "error" 
                });
            }
            setshowloader(false);
        }
    };
    
    const moveCustomerToTest = async (customerId: string) => {
        try {
            setshowloader(true);
            const response = await axios.post(
                "/payments/move_customer_to_test/",
                {
                    customer_id: customerId
                },
                { withCredentials: true }
            );
            
            if (response) {
                if (response.status === "MOVED_TO_TEST") {
                    let message = response.message;
                    if (response.results && response.results.customer) {
                        message += `\nCustomer: ${response.results.customer.old_id} → ${response.results.customer.new_id}`;
                    }
                    
                    setAlertMsgg({ 
                        ...alertMsgg, 
                        open: true, 
                        content: message, 
                        type: "success" 
                    });
                    fetch_customerlisting();
                    // Clear the check results for this customer
                    const key = `customer_${customerId}`;
                    const updatedResults = { ...stripeCheckResults };
                    delete updatedResults[key];
                    setStripeCheckResults(updatedResults);
                } else if (response.error) {
                    setAlertMsgg({ 
                        ...alertMsgg, 
                        open: true, 
                        content: response.error, 
                        type: "error" 
                    });
                }
            }
            setshowloader(false);
        } catch (error: any) {
            console.error(error);
            if (error.response) {
                setAlertMsgg({ 
                    ...alertMsgg, 
                    open: true, 
                    content: error.response.data?.error || "Error moving customer to Test mode", 
                    type: "error" 
                });
            } else {
                setAlertMsgg({ 
                    ...alertMsgg, 
                    open: true, 
                    content: "Network error", 
                    type: "error" 
                });
            }
            setshowloader(false);
        }
    };
    
    const renderStripeCheckResult = (customerId: string) => {
        const key = `customer_${customerId}`;
        const result = stripeCheckResults[key];
        
        console.log(`renderStripeCheckResult called for customerId: ${customerId}, key: ${key}`);
        console.log(`Current stripeCheckResults:`, stripeCheckResults);
        console.log(`Result for key:`, result);
        
        if (!result) {
            return null;
        }
        const existsInTest = result.exists_in_test;
        const existsInLive = result.exists_in_live;
        // Use mode_summary from backend if available, otherwise calculate it
        let modeSummary = result.mode_summary || '';
        
        if (!modeSummary) {
            if (existsInTest && existsInLive) {
                modeSummary = 'EXISTS IN BOTH TEST AND LIVE';
            } else if (existsInTest) {
                modeSummary = 'TEST MODE ONLY';
            } else if (existsInLive) {
                modeSummary = 'LIVE MODE ONLY';
            } else {
                modeSummary = 'NOT FOUND IN EITHER MODE';
            }
        }

        return (
            <div style={{
                marginTop: 8,
                padding: 12,
                background: '#f5f5f5',
                borderRadius: 8,
                fontSize: 12,
                border: '1px solid #e0e0e0'
            }}>
                <div style={{fontWeight: 600, marginBottom: 6, color: '#222'}}>
                    {modeSummary}
                </div>
                
                <div style={{fontSize: 11, color: '#666', marginBottom: 4}}>
                    Customer: {existsInTest && <span style={{color: '#f57c00'}}>TEST</span>}
                    {existsInTest && existsInLive && <span> + </span>}
                    {existsInLive && <span style={{color: '#388e3c'}}>LIVE</span>}
                </div>
                
                {/* Show Move to Live if in TEST MODE ONLY */}
                {modeSummary === 'TEST MODE ONLY' && (
                    <button
                        className="btn btn-sm btn-warning mt-2"
                        onClick={() => moveCustomerToLive(customerId)}
                        style={{fontSize: 11, padding: '4px 12px'}}
                    >
                        <i className="bx bx-transfer" style={{marginRight: 4}}></i>
                        Move to Live
                    </button>
                )}
                
                {/* Show Move to Test if in LIVE MODE ONLY */}
                {modeSummary === 'LIVE MODE ONLY' && (
                    <button
                        className="btn btn-sm btn-info mt-2"
                        onClick={() => moveCustomerToTest(customerId)}
                        style={{fontSize: 11, padding: '4px 12px'}}
                    >
                        <i className="bx bx-transfer" style={{marginRight: 4}}></i>
                        Move to Test
                    </button>
                )}
            </div>
        );
    };
    
    const fetch_customerlisting = async () => {
    try {
        setshowloader(true)
        const response = await api.get(`/accounts/unverified_customer`,{});
        if (response.status === 'unverified_customer') {
            setBookings(response.seri);
            console.log('response.seri check krni h',response.seri)
            setshowloader(false);
            

        }
        setshowloader(false);
    } catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.error, type: "error" });
            }
            else if (error.response.status === 403) {
                console.log('Error stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
              console.log('An error occurred')
              setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
            }
        } else {
          console.log('An error occurred')
          setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
        }
        setshowloader(false)
    }
    };
    useEffect(() => {   
        fetch_customerlisting();
        subscribeToTokenRefresh(() => {
            console.log("🔁 Token refreshed. Re-fetching experts...");
            fetch_customerlisting();
        }); 

    }, []);
    useEffect(() => { }, [bookings]);

    // Distinct package options
    const packageOptions = useMemo(() => {
        const names = new Set<string>();
        bookings.forEach((b:any) => {
            const name = b?.cstpack?.plat_pack?.name;
            if (name) { names.add(name); }
        });
        return Array.from(names).sort((a,b)=>a.localeCompare(b));
    }, [bookings]);

    const resetFilters = () => {
        setPaymentStatuses(['']);
        setSelectedPackage('');
        setDateFrom('');
        setDateTo('');
        setActiveOnly('');
        setHasActivePack('');
        setSubsCancelled('');
        setCanDeleteOnly(false);
    };

    // Apply filters
    const filteredData = useMemo(() => {
        return (bookings || []).filter((row:any) => {
            const rawPay = row?.cstpack?.payment_status || 'pending';
            const finalPay = (row?.cstpack?.subscrip_cancelled === true) ? 'expired' : String(rawPay).toLowerCase();
            if (paymentStatuses.length > 0 && !paymentStatuses.includes('') && !paymentStatuses.includes(finalPay)) return false;


            if (selectedPackage && row?.cstpack?.plat_pack?.name !== selectedPackage) return false;

            if (activeOnly) {
                const isActive = !!row?.user?.is_active;
                if (activeOnly === 'active' && !isActive) return false;
                if (activeOnly === 'inactive' && isActive) return false;
            }

            if (hasActivePack) {
                const val = row?.cstpack?.pack_active === true ? 'true' : 'false';
                if (val !== hasActivePack) return false;
            }

            if (subsCancelled) {
                const val = row?.cstpack?.subs_cancel === true ? 'true' : 'false';
                if (val !== subsCancelled) return false;
            }

            if (canDeleteOnly && row?.can_delete !== true) return false;

            if (dateFrom || dateTo) {
                const created = row?.cstpack?.created_at ? new Date(row?.cstpack?.created_at) : null;
                if (!created) return false;
                if (dateFrom) {
                    const from = new Date(dateFrom);
                    if (created < from) return false;
                }
                if (dateTo) {
                    const to = new Date(dateTo);
                    // include whole day for to-date
                    to.setHours(23,59,59,999);
                    if (created > to) return false;
                }
            }

            return true;
        });
    }, [bookings, paymentStatuses, selectedPackage, dateFrom, dateTo, activeOnly, hasActivePack, subsCancelled, canDeleteOnly]);
    
    document.title = "Customers | BizServe";

    return (
        <div className="page-content">
            <div className="container-fluid">
            {alertMsgg.open && (
                <Alert
                    color={alertMsgg.type === "success" ? "success" : "danger"}
                    toggle={handleAlertMsggClose}
                    style={{ fontWeight: "bold" }}
                    fade={false}
                    >
                    {alertMsgg.content}
                </Alert>
            )}
            <div className="loaderContainer" hidden={!showloader}>
                <div className="spinner">
                    <div></div>  
                    <div></div>    
                    <div></div>    
                    <div></div>    
                    <div></div>    
                    <div></div>    
                    <div></div>    
                    <div></div>    
                    <div></div>    
                    <div></div>    
                </div>
            </div>
                <Breadcrumbs title="Admin" breadcrumbItem="All Customers" />
                {alert.show && (
                    <div className={`alert alert-${alert.type}  alert-dismissible fade show`} role="alert">
                        {alert.message}
                        <button type="button" className="btn-close" onClick={() => setAlert({ ...alert, show: false })}></button>
                    </div>
                )}
                <div className="font-size-13 text-dark" onClick={() => sendNotification("Test Title", "Test Message", 3)}>
                    <p>
                    This page lists all customers on the platform along with their details and package status. You can approve or reject profiles, activate or deactivate approved profiles, and also cancel user subscriptions.
                    </p>
                </div>
                <Row>
                    <Col md={12}>
                        <Card className="rounded-4 border">
                            <CardBody>
                                {/* Filters Toggle */}
                                <div className="mb-3">
                                    <Button 
                                        color="outline-primary" 
                                        size="sm" 
                                        onClick={() => setFiltersExpanded(!filtersExpanded)}
                                        className="d-flex align-items-center"
                                    >
                                        <i className={`bx ${filtersExpanded ? 'bx-chevron-up' : 'bx-chevron-down'} me-2`}></i>
                                        Filters
                                    </Button>
                                </div>
                                
                                {/* Filters */}
                                {filtersExpanded && (
                                    <div className="mb-3 p-3 border rounded bg-light">
                                        <Row className="gy-2">
                                        <Col md={3}>
                                            <Label className="form-label">Payment status</Label>
                                            <Input type="select" multiple value={paymentStatuses} onChange={(e:any)=>{
                                                const opts = Array.from(e.target.selectedOptions).map((o:any)=>o.value);
                                                setPaymentStatuses(opts);
                                            }}>
                                                <option value="">All</option>
                                                <option value="paid">Paid</option>
                                                <option value="pending">Pending</option>
                                                <option value="failed">Failed</option>
                                                <option value="expired">Expired</option>
                                            </Input>
                                        </Col>
                                        <Col md={3}>
                                            <Label className="form-label">Package</Label>
                                            <Input type="select" value={selectedPackage} onChange={(e)=>setSelectedPackage(e.target.value)}>
                                                <option value="">All packages</option>
                                                {packageOptions.map(name => (
                                                    <option key={name} value={name}>{name}</option>
                                                ))}
                                            </Input>
                                        </Col>
                                        <Col md={3}>
                                            <Label className="form-label">Active state</Label>
                                            <Input type="select" value={activeOnly} onChange={(e)=>setActiveOnly(e.target.value)}>
                                                <option value="">All</option>
                                                <option value="active">Active</option>
                                                <option value="inactive">Inactive</option>
                                            </Input>
                                        </Col>
                                        <Col md={3}>
                                            <Label className="form-label">Has active pack</Label>
                                            <Input type="select" value={hasActivePack} onChange={(e)=>setHasActivePack(e.target.value)}>
                                                <option value="">All</option>
                                                <option value="true">Yes</option>
                                                <option value="false">No</option>
                                            </Input>
                                        </Col>
                                        <Col md={3}>
                                            <Label className="form-label">Subscription cancelled</Label>
                                            <Input type="select" value={subsCancelled} onChange={(e)=>setSubsCancelled(e.target.value)}>
                                                <option value="">All</option>
                                                <option value="true">Yes</option>
                                                <option value="false">No</option>
                                            </Input>
                                        </Col>
                                        <Col md={3}>
                                            <Label className="form-label">Created from</Label>
                                            <Input type="date" value={dateFrom} onChange={(e)=>setDateFrom(e.target.value)} />
                                        </Col>
                                        <Col md={3}>
                                            <Label className="form-label">Created to</Label>
                                            <Input type="date" value={dateTo} onChange={(e)=>setDateTo(e.target.value)} />
                                        </Col>
                                        <Col md={3} className="d-flex align-items-end">
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" id="canDeleteOnly" checked={canDeleteOnly} onChange={(e)=>setCanDeleteOnly(e.target.checked)} />
                                                <Label htmlFor="canDeleteOnly" className="form-check-label">Deletable only</Label>
                                            </div>
                                        </Col>
                                        <Col md={3} className="d-flex align-items-end">
                                            <Button color="secondary" size="sm" onClick={resetFilters}>Reset filters</Button>
                                        </Col>
                                        </Row>
                                    </div>
                                )}
                                <div className="floatInfo">
                                    <UncontrolledDropdown>
                                        <DropdownToggle type="button" className="btn btn-soft-primary btn-sm btnCircle">
                                            <i className="bx bx-info-circle font-size-18"></i>
                                        </DropdownToggle>
                                        <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-3">
                                        <table className="table table-sm mb-0">
                                            <thead>
                                                <tr>
                                                    <th colSpan={2} className="text-center">Legend</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td colSpan={2} className="fw-bold text-center">Payment Status</td>
                                                </tr>
                                                <tr>
                                                    <td><Badge className="font-size-11 badge-soft-warning">Pending</Badge></td>
                                                    <td>User hasn't subscribed yet</td>
                                                </tr>
                                                <tr>
                                                    <td><Badge className="font-size-11 badge-soft-secondary">Expired</Badge></td>
                                                    <td>User's package got expired</td>
                                                </tr>
                                                <tr>
                                                    <td><Badge className="font-size-11 badge-soft-success">Paid</Badge></td>
                                                    <td>For users who have subscribed</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={2} className="fw-bold text-center">Action</td>
                                                </tr>
                                                <tr>
                                                    <td><Badge className="font-size-11 btn btn-success">Accept</Badge></td>
                                                    <td>Approves the user</td>
                                                </tr>
                                                <tr>
                                                    <td><Badge className="font-size-11 btn btn-danger">Reject</Badge></td>
                                                    <td>Rejects the user</td>
                                                </tr>
                                                <tr>
                                                    <td><Badge className="font-size-11 badge-soft-danger">Rejected</Badge></td>
                                                    <td>User was rejected for signup request</td>
                                                </tr>
                                                <tr>
                                                    <td><Badge className="font-size-11 bg-danger">Delete</Badge></td>
                                                    <td>Delete a user (user involved within a payment cannot be deleted)</td>
                                                </tr>
                                                <tr>
                                                    <td><Badge className="font-size-11 badge-dark">Cancel</Badge></td>
                                                    <td>Cancel user's subscription</td>
                                                </tr>
                                                <tr>
                                                    <td><Badge className="font-size-11 bg-success">Toggle</Badge></td>
                                                    <td>Used for user's activation/deactivation</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                                <TableContainer
                                    columns={columns}
                                    data={filteredData || []}
                                    isGlobalFilter={true}
                                    isPagination={true}
                                    SearchPlaceholder="Search By Name..."
                                    pagination="pagination"
                                    paginationWrapper='dataTables_paginate paging_simple_numbers'
                                    tableClass="table-bordered dt-responsive table-nowrap w-100 dataTable no-footer dtr-inline"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Modal
                    isOpen={cancel_sup_popup}
                    toggle={closeCancelModal}
                    centered
                    className="rounded-4"
                    >
                    <ModalHeader className="py-3 px-4" toggle={closeCancelModal}>
                        <div className="modal-title mt-0 font-size-16 text-dark">Cancel Subscription</div>
                    </ModalHeader>
                        {alert.show && (
                            <div className={`alert alert-${alert.type} alert-dismissible fade show`} role="alert">
                                {alert.message}
                                <button type="button" className="btn-close" onClick={() => setAlert({ ...alert, show: false })}></button>
                            </div>
                        )}
                        <div className="modal-body">
                            <div className="mb-3 px-2">
                            <label className="col-form-label">
                                Are you sure you want to cancel the subscription?
                            </label>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                            type="button"
                            className="btn btn-sm btn-soft-dark"
                            onClick={closeCancelModal}
                            >
                            Cancel
                            </button>
                            <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => cancelUserId && subscriptioncancle(cancelUserId)}
                            >
                            Confirm
                            </button>
                    </div>
                </Modal>
                <Modal isOpen={modal_center_delete} toggle={() => {set_delete_delete(!modal_center_delete);}} centered className="rounded-4">
                    <ModalHeader className="py-3 px-4" toggle={() => {set_delete_delete(!modal_center_delete);}}>
                    <div className="modal-title mt-0 font-size-16 text-dark">Delete Customer</div>
                    </ModalHeader>
                    <div className="modal-body">
                    <form>
                        <div className="mb-3 px-2">
                        <label htmlFor="message-text" className="col-form-label">
                            Are you sure you want to delete this customer?
                        </label>
                        </div>
                    </form>
                    </div>
                    <div className="modal-footer">
                    <button type="button" className="btn btn-soft-dark btn-sm" onClick={() => {set_delete_delete(false);}}>
                        Cancel
                    </button>
                    <button type="button" className="btn btn-danger btn-sm" onClick={() => { handleConfirmDelete();}}>
                        Delete
                    </button>
                    </div>
                </Modal>

                {/* Customer Detail Modal */}
                <CustomerDetailModal
                    isOpen={customerDetailModal}
                    toggle={() => setCustomerDetailModal(false)}
                    customerId={selectedCustomer?.id || null}
                    customerName={selectedCustomer?.name || ''}
                    customerEmail={selectedCustomer?.email || ''}
                />
                
            </div>
        </div>
    );
}
export default AdminCustomerApprovals;